/**
 * Read a build-time variable. Works in three places: Vite-bundled code
 * (import.meta.env), plain Node scripts (process.env) and tests.
 */
export function env(name, fallback = undefined) {
  let value;
  if (
    typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env[name] !== undefined
  ) {
    value = import.meta.env[name];
  } else if (typeof process !== "undefined" && process.env && process.env[name] !== undefined) {
    value = process.env[name];
  }
  if (value === undefined || value === "") return fallback;
  return value;
}
